<hx-form-group class="hx-form-group">
  @if (label()) {
    <hx-label
      [id]="_labelId"
      [description]="label()"
      [fontWeight]="labelFontWeight()"
      [tooltip]="tooltip()"
      [tooltipPosition]="tooltipPosition()"
      [tooltipColor]="tooltipColor()"></hx-label>
  }

  <div class="hx-card-link-group__content">
    @for (card of cardsData(); track trackByCard($index, card)) {
      <hx-card-link
        [title]="card.title"
        [subtitle]="card.subtitle ?? ''"
        [appearance]="card.appearance ?? 'outlined'"
        [linkLabel]="card.linkLabel ?? 'View Resource'"
        [linkUrl]="card.linkUrl ?? ''"
        [linkTarget]="card.linkTarget ?? 'new-tab'"
        [referralLabel]="card.referralLabel ?? 'Referral Made?'"
        [notesLabel]="card.notesLabel ?? 'Referral Notes'"
        [notesPlaceholder]="card.notesPlaceholder ?? 'Notes'"
        [notesRequired]="card.notesRequired ?? false"
        [referralMade]="card.referralMade ?? false"
        [referralNotes]="card.referralNotes ?? ''"
        [disabled]="disabledState() || card.disabled"
        (referralMadeChange)="onReferralMadeChange($event, card, $index)"
        (referralNotesChange)="onReferralNotesChange($event, card, $index)"
        (linkClicked)="onLinkClicked($event, card, $index)"
        (urlCopied)="onUrlCopied($event, card, $index)" />
    }

    @if (hasProjectedCards()) {
      <ng-content />
    }
  </div>

  <div class="hx-form-subscript-wrapper">
    @if (hint()) {
      <div hx-hint class="hx-form-hint">{{ hint() }}</div>
    }
  </div>
</hx-form-group>
